export const environment = {
  production: false,
  apiUrl: 'https://rest.dev.averia.tech',
  mobileApiUrl: 'https://rest.dev.averia.tech'
};
